import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowLeft } from "lucide-react";
import ar from "@/locales/ar.json";

// Thank you page is ALWAYS Spanish, per requirements.
const ThankYou = () => {
  const t = ar.thank_you;
  return (
    <div className="bg-white min-h-[60vh] flex items-center" data-testid="thank-you-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-24 text-center">
        <div className="inline-flex items-center justify-center h-14 w-14 border border-[#C85A32] mb-6">
          <CheckCircle2 className="h-7 w-7 text-[#C85A32]" />
        </div>
        <div className="text-xs font-mono uppercase tracking-widest text-[#C85A32]">
          {t.eyebrow}
        </div>
        <h1 className="mt-3 font-serif font-bold text-3xl sm:text-4xl lg:text-5xl text-[#0B192C]">
          {t.title}
        </h1>
        <p className="mt-6 text-base text-[#1E293B] leading-relaxed">{t.body_1}</p>
        <p className="mt-4 text-sm text-[#475569] leading-relaxed">{t.body_2}</p>
        <div className="mt-10">
          <Link
            to="/"
            className="inline-flex items-center gap-2 h-11 px-6 bg-[#0B192C] text-white text-sm font-medium uppercase tracking-wider hover:bg-[#1E293B]"
            data-testid="thank-you-back-home"
          >
            <ArrowLeft className="h-4 w-4" />
            {t.back_home}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;
